export default function Code({ children }) {
  return <span className="font-semibold ">{children}</span>;
}
